import { useEffect, useState } from "react";
import axios from "axios";
import Description from "./Description";
import LoadingDots from "./LoadingDots";
import you from '../images/boy.png';
import bot from '../images/happy.png';

const Subproducts = ({ num1 }) => {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProductName, setSelectedProductName] = useState(null);
  const [time] =useState(new Date());
  useEffect(() => {
    axios
      .get(`https://dairy-api-kzjx.onrender.com/products/${num1}`)
      .then((response) => {
        if (response.data.products?.length > 0) {
          setProducts(response.data.products);
        } else {
          alert(`No products found for category ${num1}.`);
        }
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
        alert("Failed to fetch product data.");
      });
  }, [num1]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate fetching data
    setTimeout(() => setLoading(false), 1000); 
  }, []);

  return (
    <>
      <div className="frame1 animated-frame">
        {/* <img src={image} className="IMAGE" alt="logo" /> */}
        <div className="box1">
          Please choose to proceed further
          <div style={{textAlign: 'center'}}>
            {products.map((product) => (
              <button
                key={product.product_id}
                className="menu-btn"
                onClick={() => {
                  setSelectedProduct(product.product_id);
                  setSelectedProductName(product.name);

                } }
              >
                {product?.name || "Unnamed Product"}
              </button>
            ))}
          </div>
        </div>
      </div>
      {selectedProduct && (
        <>
         {loading ? (
                <div className='frame1 animated-frame'>
                    <LoadingDots />
                </div>
            ) : (
              <>
              <div className="you-time animated-frame">
              <img src={you} alt="boy" className="boy" />
              You {time?.toLocaleTimeString()}</div>
            <div className="you-message">
              <div className="frame2 animated-frame"><b>{selectedProductName}</b></div>
            </div>

            <div className='chatbot'>
              <img src={bot} alt="bot" className="bot" />
              <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>
          <Description productId={selectedProduct} />
          </>
            )}
        </>
        )}
    </>
  );
};

export default Subproducts;
